import { Box, BoxProps } from "@chakra-ui/react";
import React, { FC } from "react";

interface TableCellProps extends BoxProps {
  selected?: boolean;
}

export const TableCell: FC<TableCellProps> = ({ children, selected = false, ...rest }) => {
  return (
    <Box
      overflow="hidden"
      textOverflow="ellipsis"
      whiteSpace="nowrap"
      verticalAlign="middle"
      {...rest}
    >
      {children}
    </Box>
  );
};
